/*
 * Copyright 2022 Siemens
 */

import React from 'react';
import {Content} from '../common/content';
import {Datastores, type ResourceOption} from '../services/datastores';
import {SwwcDefaultCell, SwwcDefaultCellGroup, SwwcLabel} from '@com.siemens.plm.horizon/swwc/bindings/react';
import {CommandBar} from '../common/commandbar';

interface OptionState {
  isLoading: boolean;
  item: ResourceOption | null;
}

export class Option extends React.Component<{}, OptionState> {
  readonly #symbol = Symbol('Option');

  constructor(props: {}, state: OptionState) {
    super(props, state);
    this.state = {isLoading: true, item: null};
  }

  override componentDidMount() {
    if (super.componentDidMount) super.componentDidMount();
    Datastores.resourceOption.addObserver(this.#symbol, (value) => {
      this.setState({isLoading: value === null, item: value});
    });
  }

  override componentWillUnmount() {
    Datastores.resourceOption.removeObserver(this.#symbol);
    if (super.componentWillUnmount) super.componentWillUnmount();
  }

  #reloadData(): void {
    this.setState({isLoading: true});
    Datastores.reloadOption();
  }

  override render() {
    return (
      <Content
        section='Datastore selectable options'
        isLoading={this.state.isLoading}
      >
        <CommandBar reloadCommand={() => this.#reloadData()}></CommandBar>
        <div className='content'>
          <SwwcDefaultCellGroup
            groupTitle='Cluster'
            expanded={true}
            cellDensity='cozy'
          >
            {this.state.item &&
              this.state.item.cluster &&
              this.state.item.cluster.map((ele) => (
                <SwwcDefaultCell
                  key={ele.id}
                  cellTitle={ele.name}
                  subTitle={ele.id}
                  description={ele.description ?? ''}
                >
                  <div slot='bottom-area'>
                    <SwwcLabel label='Job limit'>
                      <span slot='content'>{ele.limit}</span>
                    </SwwcLabel>
                  </div>
                </SwwcDefaultCell>
              ))}
          </SwwcDefaultCellGroup>
          <SwwcDefaultCellGroup
            groupTitle='Nodes'
            expanded={true}
            cellDensity='cozy'
          >
            {this.state.item &&
              this.state.item.node &&
              this.state.item.node.map((ele) => (
                <SwwcDefaultCell
                  key={ele.id}
                  cellTitle={ele.name}
                  subTitle={ele.id}
                  description={ele.description ?? ''}
                />
              ))}
          </SwwcDefaultCellGroup>
          <SwwcDefaultCellGroup
            groupTitle='Templates'
            expanded={true}
            cellDensity='cozy'
          >
            {this.state.item &&
              this.state.item.image &&
              this.state.item.image.map((ele) => (
                <SwwcDefaultCell
                  key={ele.id}
                  cellTitle={ele.name}
                  subTitle={ele.id}
                  description={ele.description ?? ''}
                >
                  <div slot='bottom-area'>
                    <SwwcLabel label='Prescan version'>
                      <span slot='content'>{ele.prescan}</span>
                    </SwwcLabel>
                    <SwwcLabel label='Type'>
                      <span slot='content'>{ele.shared ? 'system' : 'custom'}</span>
                    </SwwcLabel>
                  </div>
                </SwwcDefaultCell>
              ))}
          </SwwcDefaultCellGroup>
        </div>
      </Content>
    );
  }
}
